export default __webpack_public_path__ + "static/media/KFOlCnqEu92Fr1MmEU9fBBc4AMP6lQ.a1ae8520.woff2";